module.exports = __webpack_public_path__ + "static/media/placeholderAmis.dc83b094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StickyPhone/medias/placeholderAmis.jpg
// module id = 201
// module chunks = 0